// sales-assistant-app/src/firebase.js
import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  limit,
} from 'firebase/firestore';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export async function findConfigurationByCompanyAndPasscode(companyKey, passcode) {
    const websitesRef = collection(db, 'websites');
    const q = query(
        websitesRef,
        where('publicName', '==', companyKey),
        where('passcode', '==', passcode),
        limit(1),
    );

    const snap = await getDocs(q);
    if (snap.empty) return null;

    const docSnap = snap.docs[0];

    // docSnap.id is the configuration ID used everywhere else
    return {
        id: docSnap.id,
        ...docSnap.data(),
    };
}

export async function getCompanies() {
    const snap = await getDocs(collection(db, 'websites'));
    return snap.docs.map((doc) => ({
      id: doc.id,
      name: doc.data().name,
      publicName: doc.data().publicName,
    }));
  }

async function sha256Hex(text) {
  const encoded = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

// The hash in the direct-embed URL is keyed with this secret (sha256(id + secret))
// instead of a plain sha256(id), so knowing/guessing a website ID alone isn't
// enough to compute a working link — VUE_APP_EMBED_HASH_SECRET is also required.
function hashWebsiteId(websiteId) {
  return sha256Hex(websiteId + process.env.VUE_APP_EMBED_HASH_SECRET);
}

// Used by the direct-embed route (/<hash>) to turn a keyed hash back into a
// real website document ID, without ever putting the raw Firestore ID in the
// URL. To generate a link for a given website ID, hash it the same way, e.g.
// in Node: `crypto.createHash('sha256').update(id + secret).digest('hex')`.
export async function resolveWebsiteIdByHash(hash) {
  if (!hash) return null;

  const snap = await getDocs(collection(db, 'websites'));
  for (const docSnap of snap.docs) {
    if ((await hashWebsiteId(docSnap.id)) === hash) {
      return docSnap.id;
    }
  }

  return null;
}